import { Dropdown, Option, mergeClasses } from '@fluentui/react-components';
import { fieldMeetCertainCriteriaRelationshipInputStyles } from './styles';
import { useMemo } from 'react';
import { ConditionItemType, FieldMeetCertainCriteriaType } from '../../types';
import { useAutomationRuleConditions } from '../../use-conditions';

interface Props {
	conditionId: string;
	validationError: string | null;
}

const relationshipOptions = [
	{
		label: 'This work item',
		value: 'this-work-item',
	},
	{
		label: 'Parent work item',
		value: 'parent-work-item',
	},
	{
		label: 'Sibling work items',
		value: 'sibling-work-items',
	},
	{
		label: 'Children work items',
		value: 'children-work-items',
	}
];

export default function FieldMeetCertainCriteriaRelationshipInput(props: Props) {
	const classes = fieldMeetCertainCriteriaRelationshipInputStyles();
	const {conditions, setConditions} = useAutomationRuleConditions();

	const value = useMemo(() => {
		const foundCondition = conditions.find(item => item.id === props.conditionId) as ConditionItemType;
		const relationship = foundCondition!.fieldMeetCertainCriteria!.relationship;
		return relationshipOptions.find(item => item.value === relationship)?.label || '';

	}, [conditions, props.conditionId]);
  
	return (
		<>
			<Dropdown
				className={mergeClasses(
					classes.dropdown,
					classes.conditionTypeDropdown,
					props.validationError ? classes.dropdownWithError : ''
				)}
				listbox={{
					style: {
						minWidth: 'fit-content'
					}
				}}
				appearance='underline'
				placeholder='Relationship'
				positioning="below-start"
				value={value}
				onOptionSelect={async (_, data) => {
					setConditions((oldValues) => {
						return oldValues.map((item) => {
							if (item.id === props.conditionId) {
								return {
									...item,
									fieldMeetCertainCriteria: {
										...item.fieldMeetCertainCriteria as FieldMeetCertainCriteriaType,
										relationship: data.optionValue || '',
									},
								};
							}

							return item;
						});
					});
				}}
			>
				{relationshipOptions.map((option) => (
					<Option key={option.value} value={option.value}>{option.label}</Option>
				))}
			</Dropdown>
		</>
	);
}